import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle } from 'recompose'

import * as mapModule from 'modules/map'
import * as popoverModule from 'modules/popover'

export default compose(
  connect(
    (state) => {
      return {
        group: idx(state, _ => _.groups.selected) || {}
      }
    },
    (dispatch) => {
      const actions = {
        ...mapModule,
        ...popoverModule
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  withHandlers({
    handleEditClick: props => () => {
      props.actions.showPopover(popoverModule.EDIT_GROUP, props.group)
    }
  }),
  lifecycle({
    componentDidMount() {
      const { 
        actions, group
      } = this.props
      actions.activeGroup(group)
    },
  })
)



// WEBPACK FOOTER //
// ./src/containers/groups/ManageGroupDetails/ManageGroupDetails.enhancer.js